import getConfig from "next/config";
import { runInBrowserOnly } from "helpers/common";

const { publicRuntimeConfig } = getConfig();

export const setCartData = runInBrowserOnly(cart => {
  const eventData = {
    total: cart.priceTotal,
    totalWithDiscount: cart.withDiscountTotal,
    products: cart.flattenGroups.map(item => {
      const { product, quantity } = item;
      return {
        id: product.id,
        price: product.priceOld,
        priceWithDiscount: product.price,
        name: product.name,
        quantity,
        pictureUrl: product.image,
        url: product.url,
        brand: product.brand?.name,
        brandId: product.brand?.alias,
        hasDiscount: !!product.discount,
        category: product.category?.name,
        categoryId: product.category?.id,
      };
    }),
  };

  if (cart.count > 0) {
    if (publicRuntimeConfig.IS_DEV) {
      console.log(
        "[MindBox in DEV] PopMechanicCartData, eventData:",
        eventData
      );
      return;
    }

    window.PopMechanicCartData = eventData;
  }
});

export const setProductPageData = runInBrowserOnly(product => {
  const eventData = {
    type: "product",
    product: {
      id: product.id,
      price: product.priceOld,
      priceWithDiscount: product.price,
      name: product.name,
      pictureUrl: product.image,
      brand: product.brand?.name,
      brandId: product.brand?.alias,
      hasDiscount: !!product.discount,
      category: product.category?.name,
      categoryId: product.category?.id,
    },
  };

  if (publicRuntimeConfig.IS_DEV) {
    console.log(
      "[MindBox in DEV] PopMechanicPageData Product, eventData:",
      eventData
    );
    return;
  }

  window.PopMechanicPageData = eventData;
});

export const setCategoryPageData = runInBrowserOnly(category => {
  const eventData = {
    type: "category",
    category: {
      id: category.id,
      name: category.name,
    },
  };

  if (publicRuntimeConfig.IS_DEV) {
    console.log(
      "[MindBox in DEV] PopMechanicPageData Category, eventData:",
      eventData
    );
    return;
  }

  window.PopMechanicPageData = eventData;
});

export const setHomePageData = runInBrowserOnly(() => {
  const eventData = {
    type: "info",
  };

  if (publicRuntimeConfig.IS_DEV) {
    console.log(
      "[MindBox in DEV] PopMechanicPageData Home, eventData:",
      eventData
    );
    return;
  }

  window.PopMechanicPageData = eventData;
});

export const sendAddCart = runInBrowserOnly(item => {
  const { product, quantity } = item;
  const eventData = {
    id: product.id,
    price: product.priceOld,
    priceWithDiscount: product.price,
    name: product.name,
    quantity,
    pictureUrl: product.image,
    url: product.url,
    brand: product.brand?.name,
    brandId: product.brand?.alias,
    hasDiscount: !!product.discount,
    category: product.category?.name,
    categoryId: product.category?.id,
  };

  if (publicRuntimeConfig.IS_DEV) {
    console.log("[MindBox in DEV] PopMechanicAddToCart, eventData:", eventData);
    return;
  }

  window.PopMechanicAddToCart && window.PopMechanicAddToCart(eventData);
});
